<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Подтверждение email</h1>
      <p v-if="loading">Подтверждаем email...</p>
      <p v-else-if="message" class="success-message">{{ message }}</p>
      <p v-else-if="error" class="error-message">{{ error }}</p>
      <p v-if="!loading && (message || error)" style="margin-top: 1rem">
        <router-link to="/login">Перейти ко входу</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const route = useRoute()

const loading = ref(false)
const error = ref('')
const message = ref('')

onMounted(async () => {
  const token = route.query.confirmation_token?.toString()
  if (!token) {
    error.value = 'Ссылка для подтверждения недействительна'
    return
  }

  loading.value = true

  try {
    const result = await auth.confirmEmail(token)
    message.value = result.message
  } catch (err) {
    const errors = err.response?.data?.errors
    error.value = Array.isArray(errors) ? errors.join(', ') : 'Не удалось подтвердить email'
  } finally {
    loading.value = false
  }
})
</script>
